<div class="d-flex flex-row align-items-center pagination-container">
  <a (click)="onDecreasePage()" class="d-flex justify-content-center align-items-center move-page-btn" [ngClass]="{'disabled': numOfSelectedItem <= 8}">
    <svg width="8px" height="11px" viewBox="0 0 19 41">
      <defs></defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Arrow/Left-Copy" transform="translate(-12.000000, -4.000000)" fill="#EEF2F5">
          <path d="M28.949609,44.5859918 L12,24.4995264 L28.949609,4.41407071 C29.3745432,3.90817291 30.1162287,3.86071343 30.6006146,4.29996602 C31.0869498,4.74022838 31.1356807,5.50563864 30.7107466,6.00951689 L15.1061126,24.4995264 L30.7107466,42.9905456 C31.1356807,43.4944239 31.0869498,44.2598341 30.6006146,44.6990867 C30.3784013,44.9000322 30.1045332,45 29.8306651,45 C29.5051422,45 29.1815685,44.8596411 28.949609,44.5859918 Z" id="Fill-1"></path>
        </g>
      </g>
    </svg>
  </a>
  <div class="d-flex flex-row flex-auto justify-content-center align-items-center wrapper-content">
    <span class="selected-page">{{numOfSelectedItem}}</span>
    <div>{{'common.btn.max_pagination' | translate:{maxPage: maximumItem} }}</div>
  </div>
  <a (click)="onIncreasePage()" class="d-flex justify-content-center align-items-center move-page-btn"
     [attr.disabled]="numOfSelectedItem >= maximumItem ? true : null" [ngClass]="{'disabled': numOfSelectedItem >= maximumItem}">
    <svg width="8px" height="11px" viewBox="0 0 19 41">
      <defs></defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Arrow/Right-Copy" transform="translate(-15.000000, -4.000000)" fill="#EEF2F5">
          <path d="M31.949609,44.5859918 L15,24.4995264 L31.949609,4.41407071 C32.3745432,3.90817291 33.1162287,3.86071343 33.6006146,4.29996602 C34.0869498,4.74022838 34.1356807,5.50563864 33.7107466,6.00951689 L18.1061126,24.4995264 L33.7107466,42.9905456 C34.1356807,43.4944239 34.0869498,44.2598341 33.6006146,44.6990867 C33.3784013,44.9000322 33.1045332,45 32.8306651,45 C32.5051422,45 32.1815685,44.8596411 31.949609,44.5859918 Z" id="Fill-1" transform="translate(24.500000, 24.500000) scale(-1, 1) translate(-24.500000, -24.500000) "></path>
        </g>
      </g>
    </svg>
  </a>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-pdf-export/page-count-item/page-count-item.component.html